<template>
  <div ref="scrollContainer" class="flex-1 touch-pan-y overflow-y-auto overscroll-contain bg-light-bg-disabled px-4 py-4">
    <div class="flex flex-col gap-4">
      <template v-for="message in messages" :key="message.id">
        <ChatBotMessage
          v-if="message.role === 'assistant'"
          :blocks="message.blocks"
          :disabled="disableSelectTags"
          @click-navigation="$emit('clickNavigation', $event)"
          @select-tag="$emit('selectTag', $event)"
        />
        <ChatUserMessage v-else :text="message.blocks[0]?.type === 'text' ? message.blocks[0].markdown : ''" />
      </template>

      <ChatTypingIndicator v-if="isLoading" />
      <ChatTipsBanner :active="isLoading" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ChatBotMessage from '@/wabunka-src/features/Chat/components/model/pure/ChatBotMessage/ChatBotMessage.vue';
import ChatTipsBanner from '@/wabunka-src/features/Chat/components/model/pure/ChatTipsBanner/ChatTipsBanner.vue';
import ChatTypingIndicator from '@/wabunka-src/features/Chat/components/model/pure/ChatTypingIndicator/ChatTypingIndicator.vue';
import ChatUserMessage from '@/wabunka-src/features/Chat/components/model/pure/ChatUserMessage/ChatUserMessage.vue';
import type { ChatMessage } from '@/wabunka-src/features/Chat/models/chatMessage';

interface Props {
  messages: ChatMessage[];
  isLoading: boolean;
  disableSelectTags?: boolean;
}

const props = defineProps<Props>();

defineEmits<{
  selectTag: [tag: string];
  clickNavigation: [payload: { navType: string; url?: string; label?: string }];
}>();

const scrollContainer = ref<HTMLElement>();

const scrollToBottom = () => {
  nextTick(() => {
    const container = scrollContainer.value;
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  });
};

watch(
  () => props.messages.length,
  () => scrollToBottom(),
);

watch(
  () => props.isLoading,
  () => scrollToBottom(),
);

onMounted(() => scrollToBottom());
</script>
